/**
 * Every address the default template (skin-zero) links to, in one place. These are the engine's
 * own addresses (kept as they are, Nov 2026); the Figma file "raisonne-DS" uses the same ones.
 */
export const SZ_ROUTES = {
  home: '/',
  works: '/catalog',
  series: '/catalog/collections',
  seriesDetail: (slug: string) => `/catalog/collections/${slug}`,
  work: (id: string | number) => `/catalog/artwork/${id}`,
  oneOfOnes: '/catalog/one-of-ones',
  installations: '/catalog/immersive',
  installation: (slug: string) => `/catalog/immersive/${slug}`,
  collaborations: '/catalog/collaborations',
  physicals: '/catalog/physicals',
  exhibitions: '/catalog/exhibitions',
  exhibition: (slug: string) => `/catalog/exhibitions/${slug}`,
  awards: '/catalog/awards',
  writings: '/catalog/writings',
  drops: '/catalog/drops',
  about: '/about',
  cv: '/cv',
  press: '/press',
  pressItem: (slug: string) => `/press/${slug}`,
  commissions: '/collabs',
  commissionStart: '/collabs/start',
  shop: '/store',
  product: (id: string | number) => `/store/product/${id}`,
  checkout: '/store/checkout',
  orders: '/store/orders',
  collectors: '/collectors',
  collector: (username: string) => `/collector/${username}`,
  leaderboard: '/insights/leaderboard',
  tiers: '/insights/guild',
  market: '/insights/analytics',
  signIn: '/auth/signin',
  myCollection: '/collector',
  privacy: '/privacy-policy',
  terms: '/terms-of-service',
} as const;

/** Which top-level menu a page belongs to, so the header can mark it as current. */
export type SzMenu = 'works' | 'exhibitions' | 'about' | 'shop' | 'collectors';

export function menuForPath(pathname: string): SzMenu | null {
  if (pathname.startsWith('/catalog/exhibitions')) return 'exhibitions';
  if (pathname.startsWith('/catalog/awards') || pathname.startsWith('/catalog/writings')) return 'about';
  if (pathname.startsWith('/catalog/drops')) return 'shop';
  if (pathname === '/work' || pathname.startsWith('/catalog')) return 'works';
  if (['/about', '/cv', '/press', '/collabs'].some((p) => pathname === p || pathname.startsWith(`${p}/`))) return 'about';
  if (pathname.startsWith('/store')) return 'shop';
  if (pathname.startsWith('/collectors') || pathname.startsWith('/insights') || pathname.startsWith('/collector')) return 'collectors';
  return null;
}
